(function () {
  const root = document.documentElement;

  function setHeaderHeight() {
    const wrap = document.querySelector('[data-artemest-header-wrap]');
    const announce = document.querySelector('.artemest-announcement');
    const header = document.querySelector('[data-artemest-header]');
    if (!wrap || !header) return;
    const announceH = announce ? announce.offsetHeight : 0;
    const headerH = header.offsetHeight;
    root.style.setProperty('--artemest-announce-h', announceH + 'px');
    root.style.setProperty('--artemest-header-stack', headerH + 'px');
    root.style.setProperty('--artemest-header-total', announceH + headerH + 'px');
  }

  function initHeader() {
    const header = document.querySelector('[data-artemest-header]');
    const hero = document.querySelector('.artemest-hero');
    if (!header) return;

    if (!hero) {
      header.classList.remove('is-transparent');
      header.classList.add('is-scrolled');
      setHeaderHeight();
      window.addEventListener('resize', setHeaderHeight);
      return;
    }

    const update = () => {
      const y = window.scrollY || 0;
      const threshold = Math.max(hero.offsetHeight - header.offsetHeight - 40, 60);
      const transparent = y < threshold;
      header.classList.toggle('is-transparent', transparent);
      header.classList.toggle('is-scrolled', !transparent);
    };

    setHeaderHeight();
    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', setHeaderHeight);
  }

  function initMobileMenu() {
    const openBtn = document.querySelector('[data-artemest-menu-open]');
    const drawer = document.querySelector('[data-artemest-drawer]');
    const closeEls = document.querySelectorAll('[data-artemest-drawer-close]');
    if (!openBtn || !drawer) return;

    const open = () => {
      drawer.hidden = false;
      requestAnimationFrame(() => drawer.classList.add('is-open'));
      document.body.classList.add('artemest-menu-open');
    };
    const close = () => {
      drawer.classList.remove('is-open');
      document.body.classList.remove('artemest-menu-open');
      window.setTimeout(() => {
        drawer.hidden = true;
      }, 320);
    };

    openBtn.addEventListener('click', open);
    closeEls.forEach((el) => el.addEventListener('click', close));

    drawer.querySelectorAll('[data-artemest-drawer-toggle]').forEach((toggle) => {
      toggle.addEventListener('click', () => {
        const group = toggle.closest('.artemest-drawer__nav-group');
        const subnav = group?.querySelector(':scope > [data-artemest-drawer-subnav]');
        if (!group || !subnav) return;

        const isOpen = group.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', String(isOpen));
        subnav.hidden = !isOpen;
      });
    });

    drawer.querySelectorAll('.artemest-drawer__subnav-link, .artemest-drawer__nav-link').forEach((a) => {
      a.addEventListener('click', close);
    });
  }

  function initHeaderSearch() {
    if (!document.body.classList.contains('template-index')) return;

    const form = document.querySelector('.artemest-header__search');
    const input = form?.querySelector('input[type="search"]');
    const desktop = window.matchMedia('(min-width: 768px)');
    if (!form || !input) return;

    const homeSearch = () =>
      desktop.matches && document.querySelector('[data-artemest-header]')?.classList.contains('is-transparent');

    const openSearch = () => {
      const modal = document.getElementById('search-modal');
      const dialog = modal?.querySelector('dialog');
      if (modal && typeof modal.showDialog === 'function') {
        modal.showDialog();
      } else if (dialog && typeof dialog.showModal === 'function') {
        if (!dialog.open) dialog.showModal();
      } else {
        input.focus();
        return;
      }
      window.setTimeout(() => dialog?.querySelector('input[type="search"]')?.focus(), 40);
    };

    form.addEventListener('click', (event) => {
      if (!homeSearch()) return;
      event.preventDefault();
      openSearch();
    });

    form.addEventListener('submit', (event) => {
      if (!homeSearch() || input.value.trim()) return;
      event.preventDefault();
      openSearch();
    });
  }

  function initNavDropdowns() {
    const nav = document.querySelector('[data-artemest-nav]');
    if (!nav) return;

    const stack = nav.querySelector('[data-artemest-nav-stack]') || nav;
    const rail = nav.querySelector('[data-artemest-subnav-rail]');
    const panels = nav.querySelectorAll('[data-artemest-subnav-panel]');
    const items = nav.querySelectorAll('[data-artemest-nav-dropdown]');
    if (!items.length) return;

    let closeTimer = null;

    const closeAll = () => {
      items.forEach((item) => {
        item.classList.remove('is-open');
        const caret = item.querySelector('[data-artemest-nav-caret]');
        if (caret) caret.setAttribute('aria-expanded', 'false');
      });
      rail?.classList.remove('is-open');
      panels.forEach((panel) => {
        panel.hidden = true;
      });
    };

    const placeNaturalMenu = () => {
      const panel = nav.querySelector('.artemest-header__grandchild--natural');
      if (!panel || getComputedStyle(panel).display === 'none') return;
      panel.style.left = '0px';
      const parent = panel.parentElement;
      const next = parent?.nextElementSibling;
      const rect = panel.getBoundingClientRect();
      let shift = 0;
      if (next) {
        const nextRect = next.getBoundingClientRect();
        const overlaps = rect.bottom > nextRect.top && rect.top < nextRect.bottom;
        if (overlaps) {
          const cover = rect.right - (nextRect.left - 8);
          if (cover > 0) shift = cover;
        }
      }
      const overflowRight = rect.right - shift - (window.innerWidth - 16);
      if (overflowRight > 0) shift += overflowRight;
      const nextLeft = rect.left - shift;
      if (nextLeft < 16) shift -= 16 - nextLeft;
      panel.style.left = shift > 0.5 ? `${-Math.ceil(shift)}px` : '';
    };

    nav.querySelectorAll('.artemest-header__grandchild--natural').forEach((panel) => {
      const item = panel.parentElement;
      item?.addEventListener('mouseenter', () => {
        window.requestAnimationFrame(placeNaturalMenu);
      });
      item?.addEventListener('focusin', () => {
        window.requestAnimationFrame(placeNaturalMenu);
      });
    });
    window.addEventListener('resize', placeNaturalMenu);

    const openItem = (item) => {
      closeAll();
      item.classList.add('is-open');
      const caret = item.querySelector('[data-artemest-nav-caret]');
      if (caret) caret.setAttribute('aria-expanded', 'true');

      const index = item.dataset.navIndex;
      const panel = index != null ? nav.querySelector(`[data-artemest-subnav-panel="${index}"]`) : null;
      if (panel && rail) {
        panel.hidden = false;
        rail.classList.add('is-open');
      }
    };

    const cancelClose = () => {
      window.clearTimeout(closeTimer);
    };

    const scheduleClose = () => {
      if (!window.matchMedia('(hover: hover)').matches) return;
      window.clearTimeout(closeTimer);
      closeTimer = window.setTimeout(closeAll, 180);
    };

    const desktopHover = () => window.matchMedia('(hover: hover) and (min-width: 768px)').matches;

    const pointerInOpenSeriesMenu = (x, y) => {
      const open = nav.querySelector('[data-artemest-hero-links] [data-artemest-nav-dropdown].is-open');
      const panel = rail?.querySelector('[data-artemest-subnav-panel]:not([hidden])');
      if (!open || !panel) return false;

      const trigger = open.getBoundingClientRect();
      let left = trigger.left;
      let right = trigger.right;
      let top = trigger.top;
      let bottom = trigger.bottom;

      panel.querySelectorAll('a, [data-artemest-grandchild]').forEach((link) => {
        const rect = link.getBoundingClientRect();
        if (rect.width === 0 && rect.height === 0) return;
        left = Math.min(left, rect.left);
        right = Math.max(right, rect.right);
        top = Math.min(top, rect.top);
        bottom = Math.max(bottom, rect.bottom);
      });

      const padX = 20;
      const padY = 12;
      return x >= left - padX && x <= right + padX && y >= top - padY && y <= bottom + padY;
    };

    items.forEach((item) => {
      const caret = item.querySelector('[data-artemest-nav-caret]');

      item.addEventListener('mouseenter', () => {
        if (window.matchMedia('(hover: hover)').matches) {
          cancelClose();
          openItem(item);
        }
      });

      caret?.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (item.classList.contains('is-open')) closeAll();
        else openItem(item);
      });
    });

    stack.addEventListener('mouseenter', cancelClose);
    stack.addEventListener('mouseleave', (event) => {
      const next = event.relatedTarget;
      const inHeroLinks =
        next instanceof Node &&
        Array.from(nav.querySelectorAll('[data-artemest-hero-links]')).some((group) => group.contains(next));
      if (next instanceof Node && (stack.contains(next) || inHeroLinks)) return;
      scheduleClose();
    });
    rail?.addEventListener('mouseenter', cancelClose);
    nav.querySelectorAll('[data-artemest-hero-links]').forEach((group) => {
      group.addEventListener('mouseenter', cancelClose);
      group.addEventListener('mouseleave', (event) => {
        const next = event.relatedTarget;
        if (next instanceof Node && (group.contains(next) || stack.contains(next) || rail?.contains(next))) return;
        if (next instanceof Node && nav.contains(next) && desktopHover()) return;
        scheduleClose();
      });
    });
    nav.addEventListener('mousemove', (event) => {
      if (!desktopHover()) return;
      if (!nav.querySelector('[data-artemest-hero-links] [data-artemest-nav-dropdown].is-open')) return;
      const target = event.target;
      if (
        target instanceof Node &&
        (rail?.contains(target) ||
          target.closest?.('[data-artemest-grandchild]') ||
          target.closest?.('[data-artemest-subnav-panel]') ||
          target.closest?.('[data-artemest-nav-dropdown].is-open'))
      ) {
        cancelClose();
        return;
      }
      if (pointerInOpenSeriesMenu(event.clientX, event.clientY)) cancelClose();
      else scheduleClose();
    });
    nav.addEventListener('mouseleave', (event) => {
      const next = event.relatedTarget;
      if (next instanceof Node && nav.contains(next)) return;
      scheduleClose();
    });

    document.addEventListener('click', (event) => {
      if (!nav.contains(event.target)) closeAll();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeAll();
    });
  }

  function initReveal() {
    const items = document.querySelectorAll('[data-artemest-reveal]');
    if (!items.length || !('IntersectionObserver' in window)) {
      items.forEach((el) => el.classList.add('is-visible'));
      return;
    }

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );

    items.forEach((el) => io.observe(el));
  }

  function initCarousels() {
    document.querySelectorAll('[data-artemest-carousel]').forEach((wrap) => {
      const track = wrap.querySelector('[data-artemest-carousel-track]');
      const scope = wrap.closest('section') || wrap;
      const prev =
        wrap.querySelector('[data-artemest-carousel-prev]') ||
        scope.querySelector('[data-artemest-carousel-prev]');
      const next =
        wrap.querySelector('[data-artemest-carousel-next]') ||
        scope.querySelector('[data-artemest-carousel-next]');
      if (!track) return;

      const step = () => {
        const card = track.querySelector(
          '.artemest-product-strip__item, .artemest-product-card, .artemest-category-card, .artemest-video-card, .artemest-story-card, :scope > *'
        );
        if (!card) return Math.max(track.clientWidth * 0.75, 280);
        const gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
        return card.offsetWidth + gap;
      };

      const loopAlways = wrap.hasAttribute('data-artemest-loop');
      const loopDesktopOnly = wrap.hasAttribute('data-artemest-loop-desktop');
      const desktopCarousel = window.matchMedia('(min-width: 768px)');
      const isLoop = () => loopAlways || (loopDesktopOnly && desktopCarousel.matches);
      const motion = () =>
        loopDesktopOnly && window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      let busy = false;

      const updateNav = () => {
        const maxScroll = track.scrollWidth - track.clientWidth;
        const needsNav = maxScroll > 2;

        if (isLoop()) {
          wrap.classList.remove('is-static');
          scope.classList.remove('is-static-carousel');
          if (!prev || !next) return;
          const disabled = track.children.length < 2;
          prev.hidden = false;
          next.hidden = false;
          prev.disabled = disabled;
          next.disabled = disabled;
          return;
        }

        wrap.classList.toggle('is-static', !needsNav);
        scope.classList.toggle('is-static-carousel', !needsNav);

        if (!prev || !next) return;

        prev.hidden = !needsNav;
        next.hidden = !needsNav;

        if (!needsNav) return;

        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= maxScroll - 2;
      };

      const release = () => {
        busy = false;
        updateNav();
      };

      const afterMotion = () => {
        window.setTimeout(release, 450);
      };

      const shiftInstant = (mutate) => {
        track.style.scrollBehavior = 'auto';
        track.style.scrollSnapType = 'none';
        mutate();
        track.style.scrollBehavior = '';
        track.style.scrollSnapType = '';
      };

      const flipShift = (mutate) => {
        if (motion() === 'auto') {
          mutate();
          release();
          return;
        }
        const nodes = Array.from(track.children);
        const before = new Map(nodes.map((el) => [el, el.getBoundingClientRect().left]));
        mutate();
        nodes.forEach((el) => {
          const dx = before.get(el) - el.getBoundingClientRect().left;
          if (Math.abs(dx) < 1) return;
          el.style.transition = 'none';
          el.style.transform = `translateX(${dx}px)`;
        });
        requestAnimationFrame(() => {
          nodes.forEach((el) => {
            el.style.transition = 'transform 0.35s ease';
            el.style.transform = '';
          });
        });
        window.setTimeout(() => {
          nodes.forEach((el) => {
            el.style.transition = '';
            el.style.transform = '';
          });
          release();
        }, 380);
      };

      prev?.addEventListener('click', () => {
        if (!isLoop()) {
          track.scrollBy({ left: -step(), behavior: 'smooth' });
          return;
        }
        if (busy || track.children.length < 2) return;
        const maxScroll = track.scrollWidth - track.clientWidth;
        const delta = step();
        if (maxScroll > 2 && track.scrollLeft > 2) {
          track.scrollBy({ left: -delta, behavior: motion() });
          return;
        }
        busy = true;
        if (maxScroll <= 2) {
          flipShift(() => track.insertBefore(track.lastElementChild, track.firstElementChild));
          return;
        }
        shiftInstant(() => {
          track.insertBefore(track.lastElementChild, track.firstElementChild);
          track.scrollLeft += delta;
        });
        requestAnimationFrame(() => {
          track.scrollBy({ left: -delta, behavior: motion() });
          afterMotion();
        });
      });
      next?.addEventListener('click', () => {
        if (!isLoop()) {
          track.scrollBy({ left: step(), behavior: 'smooth' });
          return;
        }
        if (busy || track.children.length < 2) return;
        const maxScroll = track.scrollWidth - track.clientWidth;
        const delta = step();
        if (maxScroll > 2 && track.scrollLeft < maxScroll - 2) {
          track.scrollBy({ left: delta, behavior: motion() });
          return;
        }
        busy = true;
        if (maxScroll <= 2) {
          flipShift(() => track.appendChild(track.firstElementChild));
          return;
        }
        shiftInstant(() => {
          track.appendChild(track.firstElementChild);
          track.scrollLeft = Math.max(0, track.scrollLeft - delta);
        });
        requestAnimationFrame(() => {
          track.scrollBy({ left: delta, behavior: motion() });
          afterMotion();
        });
      });

      track.addEventListener('scroll', updateNav, { passive: true });
      window.addEventListener('resize', updateNav);
      if (loopDesktopOnly && desktopCarousel.addEventListener) {
        desktopCarousel.addEventListener('change', updateNav);
      }

      if ('ResizeObserver' in window) {
        const ro = new ResizeObserver(updateNav);
        ro.observe(track);
        track.querySelectorAll('img').forEach((img) => {
          if (!img.complete) img.addEventListener('load', updateNav, { once: true });
        });
        track.querySelectorAll('video').forEach((video) => {
          video.addEventListener('loadedmetadata', updateNav, { once: true });
        });
      }

      updateNav();
      loadRemainingCollectionCards(track, updateNav);
    });
  }

  function formatCollectionMoney(format, price) {
    const value = Number(price);
    const amount = Number.isFinite(value) ? value.toFixed(2) : String(price);
    const noDecimals = Number.isFinite(value) ? String(Math.round(value)) : amount;
    return String(format || '{{amount}}')
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDecimals)
      .replace(/\{\{\s*amount\s*\}\}/g, amount);
  }

  function loadRemainingCollectionCards(track, updateNav) {
    const count = Number(track.dataset.collectionCount || 0);
    const url = track.dataset.collectionUrl;
    if (!url || count <= 50 || track.dataset.collectionLoaded === 'true') return;
    track.dataset.collectionLoaded = 'true';

    const seen = new Set(
      Array.from(track.querySelectorAll('a[href]'), (link) => link.getAttribute('href'))
    );
    const cardType = track.dataset.card;
    const moneyFormat = track.dataset.moneyFormat;

    const appendProduct = (product) => {
      const href = `/products/${product.handle}`;
      if (Array.from(seen).some((item) => item && item.indexOf(`/products/${product.handle}`) !== -1)) return;
      seen.add(href);

      const image = product.images && product.images[0] ? product.images[0].src : '';
      const second = product.images && product.images[1] ? product.images[1].src : '';
      const link = document.createElement('a');
      link.href = href;

      if (cardType === 'product') {
        link.className = 'artemest-product-card';
        const price = product.variants && product.variants[0] ? product.variants[0].price : '';
        link.innerHTML = `
          <div class="artemest-product-card__image">
            ${image ? `<img class="artemest-product-card__img artemest-product-card__img--primary" src="${image}" alt="" loading="lazy">` : ''}
            ${second ? `<img class="artemest-product-card__img artemest-product-card__img--secondary" src="${second}" alt="" loading="lazy">` : ''}
          </div>
          <div class="artemest-product-card__meta">
            <p class="artemest-product-card__vendor"></p>
            <h3 class="artemest-product-card__title"></h3>
            <p class="artemest-product-card__price"></p>
          </div>
        `;
        link.querySelector('.artemest-product-card__vendor').textContent = product.vendor || '';
        link.querySelector('.artemest-product-card__title').textContent = product.title || '';
        link.querySelector('.artemest-product-card__price').textContent = formatCollectionMoney(moneyFormat, price);
        if (image) link.querySelector('img').alt = product.title || '';
      } else {
        link.className = 'artemest-product-strip__item';
        if (image) {
          const img = document.createElement('img');
          img.src = image;
          img.alt = product.title || '';
          img.loading = 'lazy';
          link.appendChild(img);
        }
      }

      track.appendChild(link);
    };

    const loadPage = (page) => {
      if ((page - 1) * 50 >= count) {
        updateNav();
        return;
      }
      fetch(`${url}/products.json?limit=50&page=${page}`)
        .then((response) => (response.ok ? response.json() : null))
        .then((data) => {
          const products = data && data.products ? data.products : [];
          products.forEach(appendProduct);
          if (products.length === 50) loadPage(page + 1);
          else updateNav();
        })
        .catch(() => updateNav());
    };

    loadPage(2);
  }

  function initDragScroll() {
    const DRAG_THRESHOLD = 8;

    document.querySelectorAll('[data-artemest-carousel-track]').forEach((track) => {
      let activePointer = null;
      let startX = 0;
      let startScroll = 0;
      let isDragging = false;
      let suppressClick = false;
      let rafId = 0;

      const applyScroll = (clientX) => {
        track.scrollLeft = startScroll - (clientX - startX);
      };

      const endDrag = (event) => {
        if (activePointer === null) return;

        if (isDragging && event?.pointerId === activePointer) {
          try {
            track.releasePointerCapture(activePointer);
          } catch (error) {
            /* pointer already released */
          }
        }

        if (rafId) {
          cancelAnimationFrame(rafId);
          rafId = 0;
        }

        track.classList.remove('is-dragging');

        if (isDragging) {
          suppressClick = true;
          window.setTimeout(() => {
            suppressClick = false;
          }, 50);
          track.dispatchEvent(new Event('scroll', { bubbles: true }));
        }

        activePointer = null;
        isDragging = false;
      };

      const onPointerMove = (event) => {
        if (event.pointerId !== activePointer) return;

        const delta = event.clientX - startX;

        if (!isDragging) {
          if (Math.abs(delta) < DRAG_THRESHOLD) return;
          isDragging = true;
          track.classList.add('is-dragging');
          try {
            track.setPointerCapture(activePointer);
          } catch (error) {
            /* pointer already released */
          }
        }

        event.preventDefault();

        if (rafId) cancelAnimationFrame(rafId);
        rafId = requestAnimationFrame(() => {
          applyScroll(event.clientX);
          rafId = 0;
        });
      };

      track.addEventListener('pointerdown', (event) => {
        if (event.pointerType === 'touch') return;
        if (event.button !== 0) return;

        activePointer = event.pointerId;
        startX = event.clientX;
        startScroll = track.scrollLeft;
        isDragging = false;
        suppressClick = false;
      });

      track.addEventListener('pointermove', onPointerMove, { passive: false });
      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);

      track.addEventListener(
        'click',
        (event) => {
          if (!suppressClick) return;
          event.preventDefault();
          event.stopPropagation();
        },
        true
      );

      track.addEventListener('dragstart', (event) => {
        event.preventDefault();
      });

      track.querySelectorAll('a, img').forEach((el) => {
        el.setAttribute('draggable', 'false');
        el.addEventListener('dragstart', (event) => event.preventDefault());
      });
    });
  }

  function initHeroEditorLink() {
    if (!window.Shopify?.designMode) return;

    document.querySelectorAll('[data-artemest-hero-editor-link]').forEach((link) => {
      link.addEventListener('click', (event) => {
        event.preventDefault();
      });
    });
  }

  function initHeroParallax() {
    const heroImgs = document.querySelectorAll('.artemest-hero__img');
    if (!heroImgs.length) return;
    const desktop = window.matchMedia('(min-width: 768px)');

    const apply = () => {
      if (desktop.matches) {
        heroImgs.forEach((heroImg) => {
          heroImg.style.transform = '';
        });
        return;
      }

      const y = Math.min(window.scrollY, 800);
      heroImgs.forEach((heroImg) => {
        heroImg.style.transform = `translate3d(0, ${y * 0.12}px, 0) scale(1.08)`;
      });
    };

    apply();
    window.addEventListener('scroll', apply, { passive: true });
    desktop.addEventListener('change', apply);
  }

  function initVideoCards() {
    document.querySelectorAll('[data-artemest-video-card]').forEach((media) => {
      const video = media.querySelector('video');
      if (!video) return;

      const play = () => {
        media.classList.add('is-playing');
        video.play().catch(() => {});
      };
      const pause = () => {
        media.classList.remove('is-playing');
        video.pause();
        video.currentTime = 0;
      };

      media.addEventListener('mouseenter', play);
      media.addEventListener('mouseleave', pause);
      media.addEventListener('click', () => {
        if (video.paused) play();
        else pause();
      });
    });
  }

  function initProductGallery() {
    const mainImg = document.getElementById('artemest-pdp-main-img');
    const thumbs = document.querySelectorAll('[data-artemest-pdp-thumb]');
    const scroller = document.querySelector('[data-artemest-pdp-thumbs]');
    const videos = document.querySelectorAll('[data-artemest-pdp-video]');
    if (!mainImg || !thumbs.length) return;

    const pauseVideos = () => {
      videos.forEach((panel) => {
        panel.hidden = true;
        panel.querySelectorAll('video').forEach((video) => video.pause());
      });
    };

    const setMainImage = (src) => {
      if (!src) return;
      pauseVideos();
      mainImg.hidden = false;
      mainImg.src = src;
      mainImg.removeAttribute('srcset');
      mainImg.removeAttribute('sizes');
    };

    const showVideo = (id) => {
      const panel = document.querySelector(`[data-artemest-pdp-video="${id}"]`);
      if (!panel) return;
      pauseVideos();
      mainImg.hidden = true;
      panel.hidden = false;
    };

    const activateThumb = (btn) => {
      thumbs.forEach((el) => el.classList.remove('is-active'));
      btn.classList.add('is-active');
      btn.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    };

    thumbs.forEach((btn) => {
      btn.addEventListener('click', () => {
        if (scroller?.dataset.dragged === 'true') return;
        const type = btn.dataset.mediaType;
        if (type === 'video' || type === 'external_video') showVideo(btn.dataset.mediaId);
        else setMainImage(btn.dataset.src);
        activateThumb(btn);
      });
    });

    if (scroller && window.matchMedia('(min-width: 900px)').matches) {
      scroller.addEventListener(
        'wheel',
        (event) => {
          if (scroller.scrollHeight <= scroller.clientHeight + 2) return;
          const delta = Math.abs(event.deltaY) >= Math.abs(event.deltaX) ? event.deltaY : event.deltaX;
          if (!delta) return;
          const atStart = scroller.scrollTop <= 0 && delta < 0;
          const atEnd = scroller.scrollTop + scroller.clientHeight >= scroller.scrollHeight - 1 && delta > 0;
          if (atStart || atEnd) return;
          scroller.scrollTop += delta;
          event.preventDefault();
        },
        { passive: false }
      );

      let drag = null;
      scroller.addEventListener('pointerdown', (event) => {
        if (event.button !== 0) return;
        drag = { y: event.clientY, top: scroller.scrollTop, moved: false };
      });
      window.addEventListener('pointermove', (event) => {
        if (!drag) return;
        const delta = event.clientY - drag.y;
        if (Math.abs(delta) < 5) return;
        drag.moved = true;
        scroller.dataset.dragged = 'true';
        scroller.scrollTop = drag.top - delta;
      });
      window.addEventListener('pointerup', () => {
        if (drag?.moved) window.setTimeout(() => { delete scroller.dataset.dragged; }, 0);
        drag = null;
      });
    }

    return { setMainImage, activateThumb };
  }

  function initProductPage() {
    const jsonEl = document.getElementById('artemest-product-json');
    const variantsEl = document.getElementById('artemest-variants-json');
    const form = document.getElementById('artemest-product-form');
    const gallery = initProductGallery();
    if (!jsonEl || !form) return;

    const data = JSON.parse(jsonEl.textContent);
    const variants = variantsEl ? JSON.parse(variantsEl.textContent) : data.variants || [];
    const idInput = document.getElementById('artemest-variant-id');
    const priceEl = form.closest('[data-artemest-product]')?.querySelector('.artemest-pdp__price');
    const optionInputs = form.querySelectorAll('[data-option-position]');

    const selectedOptions = () =>
      [1, 2, 3].map((pos) => {
        const checked = form.querySelector(`[data-option-position="${pos}"]:checked`);
        return checked ? checked.value : null;
      });

    const findVariant = () => {
      const opts = selectedOptions();
      const hasAllOptions = data.options.every((_, index) => Boolean(opts[index]));
      if (!hasAllOptions) {
        return (
          variants.find((variant) => String(variant.id) === String(idInput?.value)) ||
          variants.find((variant) => variant.available !== false) ||
          variants[0]
        );
      }

      return variants.find((variant) => {
        let match = true;
        if (data.options[0] && variant.option1 !== opts[0]) match = false;
        if (data.options[1] && variant.option2 !== opts[1]) match = false;
        if (data.options[2] && variant.option3 !== opts[2]) match = false;
        return match;
      });
    };

    const formatMoney = (cents) =>
      (cents / 100).toLocaleString(undefined, {
        style: 'currency',
        currency: window.Shopify?.currency?.active || 'USD',
      });

    const syncPaymentButton = () => {
      idInput?.dispatchEvent(new Event('change', { bubbles: true }));
      idInput?.dispatchEvent(new Event('input', { bubbles: true }));
    };

    const updateVariant = () => {
      const variant = findVariant();
      if (!variant || !idInput) return;

      idInput.value = variant.id;
      syncPaymentButton();

      const current = priceEl?.querySelector('.artemest-pdp__price-current');
      if (current) current.textContent = formatMoney(variant.price);

      const btn = form.querySelector('[data-artemest-atc]');
      const stockNote = form.querySelector('[data-artemest-stock-note]');
      if (btn) {
        btn.disabled = false;
        btn.textContent = 'Add to Cart';
      }
      if (stockNote) stockNote.hidden = true;

      const variantImage =
        typeof variant.featured_image === 'string'
          ? variant.featured_image
          : variant.featured_image?.src || variant.featured_media?.preview_image?.src;

      if (variantImage) {
        gallery?.setMainImage(variantImage);
        const normalizeSrc = (url) => (url || '').split('?')[0];
        document.querySelectorAll('[data-artemest-pdp-thumb]').forEach((btn) => {
          if (normalizeSrc(btn.dataset.src) === normalizeSrc(variantImage)) {
            gallery?.activateThumb(btn);
          }
        });
      }
    };

    optionInputs.forEach((input) => {
      input.addEventListener('change', () => {
        updateVariant();
        const pos = input.dataset.optionPosition;
        const label = form.querySelector(`[data-artemest-option-selected="${pos}"]`);
        if (label) label.textContent = input.value;
        const swatchSrc = input.closest('label')?.dataset.swatchSrc;
        if (swatchSrc) gallery?.setMainImage(swatchSrc);
      });
    });

    updateVariant();
  }

  document.addEventListener('DOMContentLoaded', () => {
    setHeaderHeight();
    initHeader();
    initMobileMenu();
    initHeaderSearch();
    initNavDropdowns();
    initReveal();
    initCarousels();
    initDragScroll();
    initVideoCards();
    try {
      initProductPage();
    } catch (error) {
      console.warn('Artemest product page init failed', error);
    }
    initHeroEditorLink();
    initHeroParallax();
  });
})();
